import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import axios from "axios";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import { withRouter } from "react-router-dom";

const mapLegend = {
  position: "absolute",
  width: "15%",
  height: "30%",
  right: "1%",
  bottom: "5%",
  zIndex: "5",
  padding: "5px",
  border: "0px solid #999"
};

class LegendLayer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showStat: "block",
      openLegend: true,
      dataLegend: []
    };
  }

  UNSAFE_componentWillMount() {}

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.layerAdd != null) {
      let res = nextProps.layerAdd.split("|");
      if (res[2] != "-") {
        let url = `${res[2]}?f=pjson`;
        axios
          .get(url)
          .then(response => {
            this.setState({
              openLegend: false,
              dataLegend: response.data.layers
            });
          })
          .catch(error => {
            console.log(error);
            // this.props.history.push("/pages/login#logout");
          });
      } else {
        this.setState({ openLegend: true });
      }
    } else {
      this.setState({ openLegend: true });
    }
  }

  handleClickClose = () => {
    this.setState({ openLegend: true });
  };

  renderDataLegend = e => {
    return (
      <div>
        <span style={{ fontSize: "14px" }}>{e.layerName}</span>
        <br />
        {e.legend.map((option, index) => (
          <span padding="10" key={index}>
            <img
              src={`data:image/png;base64,${option.imageData}`}
              style={{ width: `${option.width}`, height: `${option.height}` }}
            />{" "}
            <span style={{ fontSize: "14px" }}>{option.label}</span>
            <br />
          </span>
        ))}
      </div>
    );
  };

  renderLegend = () => {
    if (this.state.dataLegend != null) {
      return (
        <div style={{ padding: "10px" }}>
          {this.state.dataLegend.map(this.renderDataLegend)}
        </div>
      );
    }
  };

  render() {
    return (
      <div style={{ display: this.state.showStat }} id="legend">
        <div style={mapLegend}>
          <div
            hidden={this.state.openLegend}
            style={{
              width: "100%",
              padding: "0",
              height: "100%",
              overflow: "auto"
            }}
          >
            <Card
              style={{
                backgroundColor: "rgb(255, 246, 246, 0.8)"
              }}
            >
              <CardHeader
                title={<span style={{ fontSize: "14px" }}>Legend</span>}
                action={
                  <IconButton
                    aria-label="close"
                    size="small"
                    edge="end"
                    onClick={this.handleClickClose}
                  >
                    <CloseIcon />
                  </IconButton>
                }
                style={{ padding: 10 }}
              />
              {this.renderLegend()}
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

LegendLayer.propTypes = {
  classes: PropTypes.object.isRequired,
  basemapLegend: PropTypes.string
};

function mapStateToProps(state) {
  return {
    blocking: state.loader,
    layerAdd: state.layerAdd
  };
}

export default withRouter(connect(mapStateToProps)(LegendLayer));
